import { useCallback, useRef } from 'react';

import useEvent from '@lyearn/core/hooks/useEvent';
import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import usePromptNavigation from '@/hooks/usePromptNavigation';

interface Params {
  isDirty?: () => boolean; // to override form dirty check
  onClose: VoidFunction;
}

const usePreserveModalForm = ({ onClose, isDirty }: Params) => {
  const { t } = useTranslation();
  const isDirtyRef = useRef(false);
  const [showDiscardDialog, { off, on }] = useToggle(false);

  const onFormChange = useCallback(({ dirty }: { dirty: boolean }) => {
    isDirtyRef.current = dirty;
  }, []);

  const enabled = useCallback(() => isDirtyRef.current, []);
  const isDirtyFn = isDirty ?? enabled;

  usePromptNavigation(isDirtyFn, t('Common:DiscardChangesDescription'));

  const onCloseModal = useEvent(() => {
    if (isDirtyFn()) {
      on();
    } else {
      onClose();
    }
  });

  return {
    onFormChange,
    onCloseModal,
    modalClosePrompt: { showDiscardDialog, onClose: off, onDiscard: onClose },
  };
};

export default usePreserveModalForm;
